import { render, staticRenderFns } from "./SelectGroup.vue?vue&type=template&id=b82f296c"
import script from "./SelectGroup.vue?vue&type=script&lang=js"
export * from "./SelectGroup.vue?vue&type=script&lang=js"
import style0 from "./SelectGroup.vue?vue&type=style&index=0&id=b82f296c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports